module.exports = __webpack_public_path__ + "img/colleges_head_ph.67dc736d.png";